// iwebsite-global-preloader.js
// Global preloader functions for entire site
// Last JS update: 2026-01-25 14:30
document.addEventListener('DOMContentLoaded', function() {
    // Check if global preloader already exists
    let globalPreloader = document.getElementById('global-preloader');
    
    // Create global preloader only if it doesn't exist
    if (!globalPreloader) {
        globalPreloader = document.createElement('div');
        globalPreloader.id = 'global-preloader';
        globalPreloader.className = 'global-preloader';
        globalPreloader.innerHTML = `
            <div class="preloader-overlay">
                <span class="loader"></span>
            </div>
        `;
        globalPreloader.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.9);
            display: none;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            backdrop-filter: blur(2px);
        `;
        
        // Add to body
        document.body.appendChild(globalPreloader);
    }
    
    // Global functions to show/hide preloader
    window.showPreloader = function() {
        globalPreloader.style.display = 'flex';
    };
    
    window.hidePreloader = function() {
        globalPreloader.style.display = 'none';
    };
    
    // Function to activate preloader in specific block
    window.activatePreloaderInBlock = function(blockSelector) {
        const block = document.querySelector(blockSelector);
        if (!block) {
            return null;
        }
        
        // Check if preloader already exists
        const existingPreloader = block.querySelector('.block-preloader');
        if (existingPreloader) {
            return function() {
                if (existingPreloader && existingPreloader.parentNode) {
                    existingPreloader.parentNode.removeChild(existingPreloader);
                }
            };
        }
        
        // Get existing global preloader
        const globalPreloader = document.getElementById('global-preloader');
        if (!globalPreloader) {
            return null;
        }
        
        // Clone global preloader
        const preloaderClone = globalPreloader.cloneNode(true);
        preloaderClone.id = 'block-preloader-' + Date.now(); // Unique ID
        preloaderClone.className = 'block-preloader';
        
        // Adjust styles for block positioning (no background)
        preloaderClone.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
        `;
        
        // Add to block
        block.style.position = 'relative';
        block.appendChild(preloaderClone);
        
        // Return hide function
        return function() {
            if (preloaderClone && preloaderClone.parentNode) {
                preloaderClone.parentNode.removeChild(preloaderClone);
            }
        };
    };
});
